import axios from "axios"

function login(email: string, password: string) {
  return axios.post("/auth", { email, password })
}

const loginAPI = { login }
export default loginAPI
